<template>
    <div v-if="loading">
        <Loader />
    </div>
    <div v-else>
        <Navbar></Navbar>
        <Banner />
        <div class="content-wrapper">
            <div class="main-content">
                <div class="container">
                    <div v-if="isAuthenticated">
                        <UserCourses :latestCourses="latestCourses" />
                    </div>
                    <!-- <div class="d-flex" :class="isAuthenticated ? 'flex-column-reverse' : 'flex-column'"> -->
                    <trending-course :TrendingCourses="latestCourses" />
                    <packages-section :Bundles="Bundles" />
                    <TopRatingCourses />

                    <PopularCategories />
                    <!---- <Experts />
                    <Feedbacks /> -->
                    <Achievements />
                    <Training />
                </div>
            </div>
            <FooterItem />
        </div>
    </div>
</template>

<script>
import TopRatingCourses from '@/components/Homepage/TopRatingCourses.vue';
import Banner from '@/components/Homepage/Banner.vue';
import Navbar from '@/components/Layout/Navbar.vue';
import TrendingCourse from '@/components/Homepage/TrendingCourse.vue';
import PopularCategories from '@/components/Homepage/PopularCategories.vue';
//import Experts from '@/components/Homepage/Experts.vue';
//import Feedbacks from '@/components/Homepage/Feedbacks.vue';
import Training from '@/components/Homepage/Training.vue';
import Achievements from '@/components/Homepage/Achievements.vue';
import FooterItem from '@/components/Layout/FooterItem.vue';
import UserCourses from '@/components/Homepage/UserCourses.vue';
import PackagesSection from '@/components/Homepage/PackagesSection.vue';
import Loader from '@/components/common/Loader.vue';
import { useHead } from '@vueuse/head';
import { mapGetters } from 'vuex';
import store from '@/store';
import { ShowBundles } from '@/Services/api/BundlesService';
import { getLatestCourses } from '@/Services/api/CoursesService';
export default {
    components: {
        PackagesSection,
        Loader,
        Navbar,
        Banner,
        TopRatingCourses,
        TrendingCourse,
        PopularCategories,
        //Experts,
        // Feedbacks,
        Achievements,
        Training,
        UserCourses,
        FooterItem
    },
    data() {
        return {
            Bundles: [],
            latestCourses: [],
            loading: false,
        }
    },
    computed: {
        ...mapGetters(['currentLanguage']),
        isAuthenticated() {
            return store.getters.isAuthenticated
        },
    },
    methods: {
        updateHeadMeta() {
            const title = this.currentLanguage === 'ar'
                ? 'بلانينج فورس - منصة التعليم الإلكتروني | طور مهاراتك بسهولة'
                : 'Planning Force - e-Learning Platform | Enhance Your Skills with Ease';

            const description = this.currentLanguage === 'ar'
                ? 'اكتشف منصة بلانينج فورس للتعليم الإلكتروني التي تقدم دورات متقدمة وذاتية التعلم لمساعدتك على تحقيق أهدافك بسهولة واحترافية.'
                : 'Discover Planning Force, the e-Learning platform offering advanced and self-paced courses to help you achieve your goals with ease and professionalism.';

            const keywords = this.currentLanguage === 'ar'
                ? 'بلانينج فورس, التعليم الإلكتروني, دورات تعليمية, تطوير الذات, تعليم عن بعد'
                : 'Planning Force, e-learning, online courses, personal development, distance learning';

            useHead({
                title: title,
                meta: [
                    { name: 'description', content: description },
                    { name: 'keywords', content: keywords },
                    { name: 'robots', content: 'index, follow' },
                    {
                        name: 'author', content: this.currentLanguage === 'ar'
                            ? 'معهد بلانينج فورس العالي للتدريب'
                            : 'Planning Force High Institute for Training'
                    },
                    { name: 'language', content: this.currentLanguage === 'ar' ? 'ar' : 'en' },

                    // Open Graph meta tags
                    { property: 'og:title', content: title },
                    { property: 'og:description', content: description },
                    { property: 'og:image', content: 'https://example.com/home-og-image.jpg' }, // Replace with your home page image URL
                    { property: 'og:url', content: 'https://example.com/' }, // Replace with your home page URL
                    { property: 'og:type', content: 'website' },

                    // Twitter Card meta tags
                    { name: 'twitter:card', content: 'summary_large_image' },
                    { name: 'twitter:title', content: title },
                    { name: 'twitter:description', content: description },
                    { name: 'twitter:image', content: 'https://example.com/home-twitter-image.jpg' }, // Replace with your home page image URL
                ],
            });
        },

        //recent courses
        async getRecentCourse() {
            this.loading = true
            try {
                const response = await getLatestCourses();
                this.latestCourses = response.data;
            } catch (error) {
                console.log(error.message)
            } finally {
                this.loading = false
            }
        },
        //async show bunbles
        async getBundles() {
            try {
                const response = await ShowBundles();
                this.Bundles = response.data.bundles;
            } catch (error) {
                console.log(error)
            }
        }
    },
    mounted() {
        //store.dispatch('GlobalData');
    },
    watch: {
        currentLanguage: {
            handler(newLang, oldLang) {
                store.dispatch("categoriesList");
                this.updateHeadMeta();
                this.getBundles();
                this.getRecentCourse();
                this.$store.dispatch('GlobalData');
            },
            immediate: true, // Run the handler immediately when the component is mounted
        }
    }
}
</script>
<style lang="scss" scoped>
.container {
    scroll-margin-top: 100px;
    /* Adjust this value if needed */
}
</style>